<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap">
      <section class="boss-contractperiod-container">
        <div class="boss-contractperiod-wrap">
          <div class="boss-posting-container">
            <div class="boss-posting-wrap boss-main-content-wrap">
              <div class="boss-layout boss-layout-vertical boss-layout-fill">
                <h2 class="boss-page-title boss-page-title-layout-title pega-page-title">
                  除外者一覧
                </h2>
                <scout-members
                  :member-objects="memberObjects"
                  display-key="excluded"
                  data-test="scout-members"
                  :count="count"
                  :count-limit="countLimit"
                  @fetch="fetch"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ScoutMembers from '@/components/organisms/ScoutMembers'
import Indicator from '@/lib/indicator'

export default {
  components: {
    ScoutMembers
  },
  data () {
    return {
      members: [],
      countLimit: 5000,
      count: 0
    }
  },
  computed: {
    memberObjects () {
      return this.members.map((member) => {
        return {
          id: member.id,
          member: member
        }
      })
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch (page = 1) {
      Indicator.emitShow()
      this.fetchExcludedCount().then(response => {
        this.$set(this, 'count', response.data)
        this.fetchExcluded(page)
      }).catch(() => {
        Indicator.emitHide()
      })
    },
    fetchExcluded (page) {
      this.$http.secured.get(`/scout/view/company/excluded_users/pages/${page}`)
        .then(response => this.setProperty(response))
        .finally(() => {
          Indicator.emitHide()
        })
    },
    setProperty (response) {
      this.$set(this, 'members', response.data)
    },
    fetchExcludedCount () {
      return this.$http.secured.get('/scout/view/company/excluded_users/_count')
    }
  }
}
</script>
